import { BizMoveLocation } from 'src/components/biz-move-location';

export default BizMoveLocation;
